<template>
  <div id="order-book">
    <div>
      <div class="sm:tw-flex">
        <button
          @click="$router.go(-1)"
          class="tw-w-9 tw-h-9 tw-rounded-full back__button tw-flex tw-justify-center tw-items-center tw-mb-4 sm:tw-mb-0 tw-mr-2"
        >
          <img src="@/assets/img/arrow-back.svg" alt="arrow" />
        </button>
        <div>
          <h3 class="tw-font-bold tw-text-xl tw-mb-2">Order Book</h3>
          <p class="tw-text-black-light">
            See all of your orders over a period of time
          </p>
        </div>
      </div>
    </div>
    <div class="tw-bg-white tw-rounded-lg tw-px-4 tw-py-6 tw-my-14">
      <OrderBookTable />
    </div>
  </div>
</template>

<script>
import OrderBookTable from "@/components/tables/OrderBookTable";

export default {
  name: "InvestOrderbook",

  components: {
    OrderBookTable,
  },
};
</script>

<style lang="scss" scoped></style>
